// mapelements/VOR.js
import React, { useEffect, useState } from "react";

const AMA = ({ map }) => {

  const [isVisible, setIsVisible] = useState(
    localStorage.getItem("amaVisible") === "true"
  );

  const toggleVisibility = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);
    localStorage.setItem("amaVisible", newVisibility.toString()); // Save state
  };

  // Add or remove the VOR layer
  useEffect(() => {
    if (!map) return;
    const handleMapLoad = () => {
      if (isVisible) {
        map.setLayoutProperty("amasectors-text", "visibility", "visible");
        map.setLayoutProperty("amasectors-lines", "visibility", "visible");
      } else {
        map.setLayoutProperty("amasectors-text", "visibility", "none");
        map.setLayoutProperty("amasectors-lines", "visibility", "none");
      }
    };

    if (map) {
      handleMapLoad(); 
    } else {
      map.on("load", handleMapLoad);
    }

    // Cleanup
    return () => {
      if (map) {
        map.setLayoutProperty("amasectors-text", "visibility", "none");
        map.setLayoutProperty("amasectors-lines", "visibility", "none");
      }
      map.off("load", handleMapLoad);
    };
  }, [map, isVisible]);

  return (
    <button
        data-tooltip-id="map-buttons-tooltip"
        data-tooltip-content="Area minimum ALT"
        className={`w-8 h-8 ${isVisible ? "bg-gray-600" : "bg-gray-400"} text-white flex items-center justify-center`}
        onClick={toggleVisibility}
    >
        <span role="img" aria-label="FIX" className="text-sm">AMA</span>
    </button>
  );
};

export default AMA;